import { ZoneId } from '@js-joda/core';
import {
  DecimalSeparator,
  MetricPressureUnit,
  ProjectDto,
  ThousandsSeparator
} from 'providers/api';
import { ReactNode } from 'react';
import { getEffectiveModules } from 'utils/projectModules';
import ProjectContext, { IProjectContext } from './context';

export interface ProjectProviderProps {
  children: ReactNode;
  project: ProjectDto;
}

const ProjectProvider = ({ project, children }: ProjectProviderProps) => {
  const decimalSeparator = project.decimalSeparator === DecimalSeparator.Comma
    ? DecimalSeparator.Comma
    : DecimalSeparator.Dot;
  let thousandsSeparator: ThousandsSeparator = ThousandsSeparator.Comma;
  if (project.thousandsSeparator === ThousandsSeparator.Space) {
    thousandsSeparator = ThousandsSeparator.Space;
  } else if (project.thousandsSeparator === ThousandsSeparator.Dot) {
    thousandsSeparator = ThousandsSeparator.Dot;
  }

  const value: IProjectContext = {
    state: {
      timeZone: ZoneId.of(project.timeZone),
      projectId: project.entityId,
      clientId: project.client.entityId,
      enabledModules: getEffectiveModules(project.enabledModules, project.isPatersonAndCookeProject),
      decimalSeparator,
      thousandsSeparator,
      metricPressureUnit: project.metricPressureUnit ?? MetricPressureUnit.Bar,
    },
  };

  return (
    <ProjectContext.Provider value={value}>
      {children}
    </ProjectContext.Provider>
  );
};

export default ProjectProvider;
